import React from "react";
import Modal from "react-modal";
import {  CloseButtonFloatContainer, ModalContent } from "./style";
import { ButtonClose } from "../buttons/button-close";


if (typeof window !== "undefined") {
    Modal.setAppElement("#root");
}

type ModalProps = {
    isOpen: boolean;
    onRequestClose: () => void;
    children: React.ReactNode;
    contentLabel?: string;
    hideHeader?: boolean;
};

export const CustomModal = ({
    isOpen,
    onRequestClose,
    children,
    contentLabel = "Modal",
}: ModalProps) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel={contentLabel}
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.75)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                },
                content: {
                    position: "relative",
                    inset: "auto",
                    border: "none",
                    background: "#0D0D0D",
                    padding: "0",
                    maxWidth: "90%",
                    maxHeight: "90%",
                    overflow: "auto",
                },
            }}
        >

            <ModalContent>
                <CloseButtonFloatContainer>
                    <ButtonClose onClick={onRequestClose} />
                </CloseButtonFloatContainer>
                {children}
            </ModalContent>
        </Modal>
    );
};

